export const CALENDAR_MODE = 'panama_monday_sunday_v1';
export const businessDate = (value) => {
    if (!value) return '';
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Panama', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(value));
    const get = (key) => parts.find(part => part.type === key)?.value;
    return `${get('year')}-${get('month')}-${get('day')}`;
};
export const pickerDate = (value) => value ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}` : '';
export const cycleDateRange = (cycle) => {
    const literal = value => {
        if (!value || Number.isNaN(new Date(value).getTime())) return '';
        return cycle?.calendarMode === CALENDAR_MODE ? businessDate(value) : new Date(value).toISOString().slice(0, 10);
    };
    return { startDate: literal(cycle?.startDate), endDate: literal(cycle?.endDate) };
};
export const calendarWeekCount = (from, to) => {
    const start = new Date(`${from}T12:00:00Z`), end = new Date(`${to}T12:00:00Z`);
    if (!from || !to || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 0;
    const days = Math.round((end - start) / 86400000) + 1;
    const firstDays = 7 - ((start.getUTCDay() + 6) % 7);
    return 1 + Math.max(0, Math.ceil((days - firstDays) / 7));
};
export const previousQuarterBaseline = (cycle) => {
    if (cycle?.calendarMode !== CALENDAR_MODE) return { top10BaselineFrom: '2026-07-01', top10BaselineTo: '2026-07-31' };
    const named = String(cycle.name || '').match(/\bQ([1-4])\s+(20\d{2})\b/);
    const date = named ? new Date(Date.UTC(Number(named[2]), (Number(named[1]) - 1) * 3, 1)) : new Date(`${businessDate(cycle.startDate)}T12:00:00Z`);
    const month = Math.floor(date.getUTCMonth() / 3) * 3;
    const start = new Date(Date.UTC(date.getUTCFullYear(), month - 3, 1));
    const end = new Date(Date.UTC(date.getUTCFullYear(), month, 0));
    return { top10BaselineFrom: start.toISOString().slice(0, 10), top10BaselineTo: end.toISOString().slice(0, 10) };
};
export const nextQuarter = (source) => {
    const date = new Date(`${businessDate(source.endDate)}T12:00:00Z`);
    const start = new Date(Date.UTC(date.getUTCFullYear(), Math.floor(date.getUTCMonth() / 3) * 3 + 3, 1));
    const end = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 3, 0));
    return { name: `Q${Math.floor(start.getUTCMonth() / 3) + 1} ${start.getUTCFullYear()}`, startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
};
export const defaultCycle = (cycles, now = new Date()) => {
    const ready = cycles.filter(c => !c.copyPreparation || c.copyPreparation.state === 'ready');
    const active = ready.filter(c => c.status === 'active' && new Date(c.startDate) <= now).sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
    return active.find(c => new Date(c.endDate) >= now) || active[0] || ready[0] || null;
};
